import initialState from './initial';
import { actionTypes } from './actions';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload?.[actionTypes.ACTION_PROCESSING]
      };
    case actionTypes.GET_SPORT_HISTORY:
      return {
        ...state,
        coupons: action.payload?.[actionTypes.GET_SPORT_HISTORY]
      }
    case actionTypes.GET_COUPON_BETS:
      return {
        ...state,
        bets: action.payload?.[actionTypes.GET_COUPON_BETS]
      }
    default:
      return state;
  }
}
